import React from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { buildOrderInfoLines, useDefaultQueryFields } from '../order.effect';
import { useStaffMap } from '../../../services/store/organization.store';
import { Typography } from 'antd';

const { Text } = Typography;

const PendingDecisionList: React.FC = () => {
  const tabScene = OrderTabScene.GroupDecision;
  const queryFields = useDefaultQueryFields(tabScene);
  const { staffMap } = useStaffMap();

  const renderInfo = (order: MergedOrder) => {
    const lines = buildOrderInfoLines(order, staffMap, ['preprocessOperator', 'auditOperator', 'auditConclusion']);
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {lines.map((line, idx) => (
          <Text key={idx} style={{ color: line.color || '#1677ff' }}>
            {line.label}: {line.value}
          </Text>
        ))}
      </div>
    );
  };

  const renderTableActions = (order: MergedOrder, context?: any) => {
    const sceneKey = context?.scene || tabScene;
    const targets: OrderTriggerTarget[] = ['reportView', 'orderReaudit'];

    const supplementMaterials = order.audit?.supplementMaterials;
    const hasSupplementMaterials = supplementMaterials && (
      (Array.isArray(supplementMaterials) && supplementMaterials.length > 0) ||
      (!Array.isArray(supplementMaterials) && Object.keys(supplementMaterials).length > 0)
    );

    const prepayVoucher = order.audit?.prepayVoucher;
    const hasPrepayVoucher = Array.isArray(prepayVoucher) ? prepayVoucher.length > 0 : !!prepayVoucher;

    const canQuickDecision = sceneKey === 'tab_decision_supplemented' || 
                             sceneKey === 'tab_decision_prepaid' || 
                             hasSupplementMaterials || 
                             hasPrepayVoucher;

    if (sceneKey === 'tab_decision_all') {
      if (order.order.platformDeliveryTime) {
        targets.push('interceptRequest');
      } 
      if (hasSupplementMaterials) targets.push('supplementAction');
      if (hasPrepayVoucher) targets.push('prepayAction');
      if (canQuickDecision) targets.push('decisionAction');
    } else if (sceneKey === 'tab_decision_interrupted') {
      // targets.push('cancelReasonView');
    } else if (sceneKey === 'tab_decision_supplemented') {
      targets.push('supplementAction', 'decisionAction');
    } else if (sceneKey === 'tab_decision_prepaid') {
      targets.push('prepayAction', 'decisionAction');
    } else {
      if (hasSupplementMaterials) targets.push('supplementAction');
      if (hasPrepayVoucher) targets.push('prepayAction');
      if (canQuickDecision) targets.push('decisionAction');
    }

    return <OrderTriggerActionMap layout="list" targets={targets} order={order} />;
  };

  return (
    <OrderTriggerActionProvider>
      <OrderListTemplate
        tabScene={tabScene}
        defaultScene='tab_decision_all'
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'list',
            label: '产品页',
            renderActions: renderTableActions,
            renderInfo,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default PendingDecisionList;
